require('./InventoryAndTransfersAdjustsModal.scss');

const React = require('react'),
    SessionStore = require('stores/SessionStore'),
    {t} = require('services/i18nextWrapper'),
    ComponentUtils = require('utils/ComponentUtils'),
    ContentUtils = require('utils/ContentUtils'),
    Notification = require('components/Notification/Notification'),
    NumberUtils = require('utils/NumberUtils'),
    {Navigation} = require('react-router'),
    {delay} = require('lodash/function'),
    {FlatButton, SelectField, TextField} = require('material-ui'),
    get = require('lodash/object').get,
    CustomModal = require('components/Commons/CustomModal/CustomModal'),
    InventoryStore = require('stores/InventoryStore'),
    {findIndex} = require('lodash/array'),
    {PropTypes} = require('react');

const InventoryAndTransfersAdjustsModal = React.createClass({displayName: "InventoryAndTransfersAdjustsModal",

        mixins: [Navigation],

        propTypes: {
            selectedLocationItem: PropTypes.object,
            items: PropTypes.array,
            locations: PropTypes.array,
            onClose: PropTypes.function
        },

        _inputAmountToAdjust: null,

        getInitialState() {
            return {
                isVisible: false,
                title: t('inventory_and_transfer_subtitle'),
                locationsFromMessageError: '',
                locationsToIndex: 1, // select the fist location items
                adjustAmount: 0,
                locationsToMessageError: '',
                locationsAmountMessageError: '',
                itemMessageError: ''
            };
        },

        componentWillUnmount(){
        },

        focusAmount() {
            if (this._inputAmountToAdjust) {
                delay(() => {
                    this._inputAmountToAdjust.getDOMNode().querySelector('input').focus();
                }, 500); // give time to finish open dialog transition
            }
        },

        _onSaveAndClose() {
            const selectedLocationItem = this.props.selectedLocationItem;
            const isProposal = get(selectedLocationItem, 'isProposalItem');
            const adjustValue = this._inputAmountToAdjust.getDOMNode().querySelector('input').value;
            const self = this;
            const locationItemAdjust = {
                id: get(selectedLocationItem, 'id'),
                amount: NumberUtils.standardiseDecimalFormatNumber(adjustValue),
                locationId: get(selectedLocationItem, 'locationId') || get(selectedLocationItem, 'location.id'),
                location: get(selectedLocationItem, 'location'),
                itemId: get(selectedLocationItem, 'itemId') || get(selectedLocationItem, 'item.id'),
                item: get(selectedLocationItem, 'item')
            };

            if (isProposal) {
                InventoryStore.addLocationItem(locationItemAdjust, response => {
                    Notification.show(t('inventory_and_transfer_adjust_success'), 'success');
                    if (response) {
                        const locationItemChanged = JSON.parse(response.responseText);
                        self.transitionTo('/location-item/page/:page', {page: 0}, {selectLocationItemId: get(locationItemChanged, 'id')});
                    }
                    self.close();
                }, () => {
                    Notification.show(t('dashboard_notification_something_was_wrong'));
                });
            } else {
                InventoryStore.changeLocationItem(locationItemAdjust, () => {
                    Notification.show(t('inventory_and_transfer_adjust_success'), 'success');
                    self.close();
                }, () => {
                    Notification.show(t('dashboard_notification_something_was_wrong'));
                });
            }
        },

        show() {
            this.setState({
                isVisible: true
            }, () => {
                this.focusAmount();
            });
        },

        close() {
            const self = this;
            this.setState({
                isVisible: false
            }, () => {
                self.props.onClose();
            });
        },

        _onChangeLocationTo(evt, index, locationSelected) {
            this.setState({
                locationsToIndex: get(locationSelected, 'payload')
            });
        },

        _onChangeAmount(evt) {
            const adjustAmountString = NumberUtils.getNumberString(get(evt, 'target.value'));
            const adjustAmount = NumberUtils.standardiseDecimalFormatNumber(adjustAmountString);
            this.setState({
                adjustAmount
            });
        },

        _onChangeItem(evt, index, itemSelected) {
            this.setState({
                itemsIndex: get(itemSelected, 'payload')
            });
        },

        _getContentEl(selectedLocationItem) {
            const unit = get(selectedLocationItem, 'unit', '');
            const selectedLocationName = get(selectedLocationItem, 'locationName', '');
            const selectedItemName = get(selectedLocationItem, 'description', '');
            const unitWithParenthesis = unit ? '(' + unit + ')' : unit;

            const enableLocations = ContentUtils.filterEnable(this.props.locations);
            const enableItems = ContentUtils.filterEnable(this.props.items);
            const locationMenuItems = ComponentUtils.toMenuItemsWithNonSelectedItem(enableLocations, t('inventory_and_transfer_select_location_placeholder'));
            const itemMenuItems = ComponentUtils.toMenuItemsWithNonSelectedItem(enableItems, t('inventory_and_transfer_select_items_placeholder'), 'description');

            const locationIndexFrom = findIndex(enableLocations, locationItem => get(locationItem, 'name') === selectedLocationName) + 1;
            const itemIndexFrom = findIndex(enableItems, item => get(item, 'description') === selectedItemName) + 1;
            const currentAmount = NumberUtils.formatDecimal(get(selectedLocationItem, 'amount'),get(SessionStore.getCurrentCurrencyDigits(), 'value'));

            const haveVolumedDefined = NumberUtils.toNumber(currentAmount) > 0;

            return (
                React.createElement("div", {className: "bp-location-adjusts-modal"}, 
                    React.createElement("div", {className: "bp-location-adjusts-modal__header"}, 
                        React.createElement("h4", {className: "bp-location-adjusts-modal__header-title"}, t('inventory_and_transfer_title')), 
                        React.createElement("hr", null), 
                        React.createElement("div", {className: "bp-location-adjusts-modal__fields"}, 
                            React.createElement(SelectField, {
                                floatingLabelText: t('inventory_and_transfer_location'), 
                                menuItems: locationMenuItems, 
                                errorText:  this.state.locationsFromMessageError, 
                                value: locationIndexFrom, 
                                disabled: true 
                            }
                            ), 
                            React.createElement(SelectField, {
                                floatingLabelText: `${t('inventory_and_transfer_items')} ${unitWithParenthesis}`, 
                                menuItems: itemMenuItems, 
                                errorText:  this.state.itemMessageError, 
                                value: itemIndexFrom, 
                                disabled: true 
                            }
                            ), 
                            React.createElement(TextField, {
                                ref: input => this._inputAmountToAdjust = input, 
                                className: "bp-location-adjusts-modal__input", 
                                defaultValue: currentAmount, 
                                floatingLabelText: `${t('inventory_and_transfer_amount')} ${unitWithParenthesis}`, 
                                disabled: true }
                            ), 
                            React.createElement(TextField, {
                                ref: input => this._inputAmountToAdjust = input, 
                                className: "bp-location-adjusts-modal__input", 
                                defaultValue: haveVolumedDefined ? currentAmount : '', 
                                hintText: t('inventory_and_transfer_enter_amount'), 
                                floatingLabelText: `${t('inventory_and_transfer_adjust_amount')} ${unitWithParenthesis}`, 
                                onEnterKeyDown: this._onSaveAndClose, 
                                onBlur:  this._onChangeAmount}
                            )
                        )
                    )
                )
            );
        },

        _getActionsModal() {
            return [
                React.createElement(FlatButton, {
                    label: t('inventory_and_transfer_label_buttom_cancel'), 
                    onTouchTap:  this.close
                }
                ),
                React.createElement(FlatButton, {
                    label: t('inventory_and_transfer_label_buttom_save'), 
                    onTouchTap:  this._onSaveAndClose, 
                    primary: true
                }
                )
            ];
        },

        render() {
            const {selectedLocationItem, selectedModule} = this.props;

            if (!selectedLocationItem) {
                return null;
            }

            const actionsEl = this._getActionsModal(selectedLocationItem);
            const contentEl = this._getContentEl(selectedLocationItem, selectedModule);

            return (
                React.createElement(CustomModal, {
                    customClass: "inventory-transfer-modal modal-adjust", 
                    actions: actionsEl, 
                    title: this.state.title, 
                    isVisible: this.state.isVisible
                }, 
                    contentEl 
                )
            );
        }
    })
;


module.exports = InventoryAndTransfersAdjustsModal;



/** WEBPACK FOOTER **
 ** ./src/views/InventoryAndTransfersAdmin/InventoryAndTransfersAdjustsModal/InventoryAndTransfersAdjustsModal.jsx
 **/